import { CONNECTION_QUALITY } from "./constants";

export const useLivekitLocalSignal = () => ({
  localPeerDownlinkQuality: CONNECTION_QUALITY["unknown"],
});
